import { render, staticRenderFns } from "./Recompose.vue?vue&type=template&id=94dfee42&scoped=true&"
import script from "./Recompose.vue?vue&type=script&lang=js&"
export * from "./Recompose.vue?vue&type=script&lang=js&"
import style0 from "./Recompose.vue?vue&type=style&index=0&id=94dfee42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dfee42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSelect,VTextField})
